/* eslint-disable no-prototype-builtins */
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Answer } from 'app/shared/models/Answer.model';
import { CustomAlertModalComponent } from 'app/shared/shared-component/custom-alert-modal/custom-alert-modal.component';
import {CustomConfirmModalComponent} from 'app/shared/shared-component/custom-confirm-modal/custom-confirm-modal.component';
import { BussinessRegAppService } from 'app/service/business-reg-app/bussiness-reg-app.service';
import { Questionnaire } from 'app/shared/models/Questionnaire.modal';
import { clearError, processTextField } from 'app/shared/Validator/TRCQues.validator';
import { BUSINESS_REG_APP_CONSTANT } from 'app/config/business-reg-app.constant';
// import { Questionnaire } from 'app/shared/models/Questionnaire.modal';

@Component({
	selector: 'jhi-dsp-questions-answers',
	templateUrl: './dsp-questions-answers.component.html',
	styleUrls: ['./dsp-questions-answers.component.scss']
})
export class DspQuestionsAnswersComponent implements OnInit, OnChanges {

	@Input() parentForm: any;
	@Input() qQuestions: any = [];
	@Input() DispOnlyInd = "";
	@Input() DispSeqType = "A"
	@Input() DispSeqInd = "Y"
	
	@Output() errorBlock = new EventEmitter()
	
	parentArray: string[] = []
	childArray: string[] = []
	// store answers for questions here
	answers: Answer[] = []
	TRCAlphaList = "a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z".split(",");
	@Output() answerAdded: EventEmitter<Answer[]> = new EventEmitter<Answer[]>();
	@Output() parentChildList: EventEmitter<any> = new EventEmitter<any>();
	ngbModalOptions: NgbModalOptions = {
		backdrop: 'static',
		keyboard: false
	};
	qFastTrackGrp: any;
	eAppRegConstant = BUSINESS_REG_APP_CONSTANT;
	isSelected = false
	isNextlevel = false
	currrLvl = "2";
	nextLvl = "3";
	fcQuestionIds: number[]=[]
	fastTracklevel1Questions: Questionnaire[] = [];
    childFtQuestions: Questionnaire[] = [];
	
	
	

	//levelForm  = this.fb.group({})
	TRCQForms: Answer[] = JSON.parse(sessionStorage.getItem("TRCQForms") ?? "")
	constructor(private fb: FormBuilder, private modalService: NgbModal, private router: Router, private businessRegAppService: BussinessRegAppService) {
		// empty
	}

	ngOnInit(): void {
		const temp = "eappreg"
		
	}
	ngOnChanges(): void {
		switch (sessionStorage.getItem("TRCCurrGrpMetaName") ?? "") {
			case "DUPENTRYGRP":
				this.answers = JSON.parse(sessionStorage.getItem("TRCQForms") ?? "[]");
				break;
			case "BUSINESSGRP":
				this.answers = JSON.parse(sessionStorage.getItem("TRCQForms") ?? "[]");
				break;
			case "FASTTRACKGRP":
				this.answers = JSON.parse(sessionStorage.getItem("TRCQForms") ?? "[]");
				break;
			case "POLICEGRP":
				this.answers = JSON.parse(sessionStorage.getItem("TRCPLCForm") ?? "[]");
				break;
			
			case "FIREGRP":
				this.answers = JSON.parse(sessionStorage.getItem("TRCFREForm") ?? "[]");
				break;
			case "TOBACCOGRP":
				this.answers = JSON.parse(sessionStorage.getItem("TRCTBCForm") ?? "[]");
				break;
			default: {
				const modalRef = this.modalService.open(CustomAlertModalComponent, this.ngbModalOptions)
				modalRef.componentInstance.cModalTitle = "Confirmation"
				modalRef.componentInstance.cModalBody = "Validation error.  Please try again and if error persists, try again in 24 hours. The support group has already been notified via email and will respond to the problem as soon as possible."
				modalRef.result.then((userResponse) => {
					if (userResponse === "OK") {
						this.router.navigate(['/eappreg_criteria'])
						return;
					}
				});
			}
		}
		this.processDspQA()
	}

	getTRCAlphaList(idx: number): string {

		return this.TRCAlphaList[idx];
	}

	processDspQA(): void {
		if (null !== this.qQuestions && this.qQuestions !== undefined) {
			for (let i = 0; i < this.qQuestions.length; i++) {
				const ansTxtObj = this.getAnsObjFromMetaName(this.qQuestions[i].metaName)
				if (ansTxtObj === undefined) {
					const answerObj = new Answer();
					answerObj.metaName = this.qQuestions[i].metaName
					answerObj.questionId = this.qQuestions[i].questionId
					this.answers.push(answerObj)
				}
				this.qQuestions[i].answerTxt = ansTxtObj === undefined ? "" : ansTxtObj.answerTxt
				if (this.DispOnlyInd !== "Y") {
					if (this.qQuestions[i].questionType === 'DATE') {
						this.parentForm.addControl(`dt${String(this.qQuestions[i].metaName)}`, this.fb.control(this.qQuestions[i].answerTxt))
					} else {
						this.parentForm.addControl(this.qQuestions[i].metaName, this.fb.control(this.qQuestions[i].answerTxt))
					}
				}
				if (this.qQuestions[i].dependency) {
					const parentMetaName = this.answers.find(obj => obj.questionId === this.qQuestions[i].dependency);
					this.parentArray.push(parentMetaName?.metaName ?? "")
					this.childArray.push(this.qQuestions[i].metaName)
				}
			}
		}
	}
	getAnsObjFromMetaName(metaName: string): Answer | undefined {
		return this.answers.find(obj => obj.metaName === metaName);
	}

	ngAfterViewInit(): void {
		this.answerAdded.emit(this.answers);
		this.parentChildList.emit({
			parentList: this.parentArray,
			childList: this.childArray
		})
	}

	isYes(question: Answer, event: any): void {
		const fundclIndex = this.answers.findIndex(obj => obj.metaName === question.metaName)
		if (fundclIndex >= 0) {
			for (let i = 0; i < this.qQuestions.length; i++) {
				if (question.questionId === this.qQuestions[i].questionId) {
					this.qQuestions[i].answerTxt = event.target.value
					if (event.target.value === 'Y') {
						this.businessRegAppService.getTRCCurrLevelQues(sessionStorage.getItem("TRCBusGrpId") ?? "", this.currrLvl, question.questionId).subscribe((res: any) => {
							this.qQuestions[i].childQuestions = res;
							if (null !== this.qQuestions[i].childQuestions && this.qQuestions[i].childQuestions !== undefined && this.qQuestions[i].childQuestions.length >= 0) {
								this.isSelected = true;
								this.isNextlevel = true;
							}
							else {
								this.isSelected = true;
								this.isNextlevel = false;
							}
						})
					}
					else if (event.target.value === 'N') {
						if (this.qQuestions[i].childQuestions && this.qQuestions[i].childQuestions.length > 0) {
							this.TRCQForms=JSON.parse(sessionStorage.getItem("TRCQForms") ?? "")
							for (let j = 0; j < this.qQuestions[i].childQuestions.length; j++) {
								const indexOfObject = this.TRCQForms.findIndex(obj => obj.metaName === this.qQuestions[i].childQuestions[j]?.metaName)
								if (indexOfObject !== -1) {
									this.parentForm.controls[this.qQuestions[i].childQuestions[j].metaName].setValue('');
									this.fcQuestionIds.push(this.qQuestions[i].childQuestions[j].questionId);
								}
							}
							if(this.fcQuestionIds.length>0){
							this.businessRegAppService.getTRCCurrFCLevelQues(sessionStorage.getItem("TRCBusGrpId") ?? "", this.nextLvl,this.fcQuestionIds).subscribe((res: any) => {
							this.qQuestions[i].fcQuestions= res;
							if (null!==this.qQuestions[i].fcQuestions && this.qQuestions[i].fcQuestions!==undefined && this.qQuestions[i].fcQuestions.length > 0) {
								for(let x = 0; x < this.qQuestions[i].fcQuestions.length; x++){
								const indxOfObject = this.TRCQForms.findIndex(obj => obj.metaName === this.qQuestions[i].fcQuestions[x]?.metaName)
							if (indxOfObject !== -1) {
									this.parentForm.controls[this.qQuestions[i].fcQuestions[x].metaName].setValue('');
								}
								
							}
							}
						})
						}
						}
					}
				}
			}
		}
		else {
			this.isSelected = false;
			this.isNextlevel = false
		}
	}
	
	

	
	update(answers: Answer[]): void {
		
		this.TRCQForms = JSON.parse(sessionStorage.getItem("TRCQForms") ?? "")
		for (let i = 0; i < answers.length; i++) {
			if (!this.TRCQForms.find(ansObj => ansObj.questionId === answers[i].questionId)) {
				this.TRCQForms.push(answers[i])
			}
		}
		sessionStorage.setItem("TRCQForms", JSON.stringify(this.TRCQForms))
		 this.data()
	}
	data(): void {

    const inputElem: any = document.getElementById("level1_table")?.getElementsByTagName("input");

    for (let i = 0; i < inputElem?.length; i++) {
      if (inputElem[i].type === 'radio') {
        (<HTMLElement>inputElem[i]).addEventListener('click', () => {
          clearError(inputElem[i]);
        });
      }
      if (inputElem[i].type === 'text') {
        (<HTMLElement>inputElem[i]).addEventListener('change', () => {
          processTextField(inputElem[i], this.modalService);
        })
      }
    }
  }

data1(): void {

    const inputElem: any = document.getElementById("level1_table")?.getElementsByTagName("input");

    for (let i = 0; i < inputElem?.length; i++) {
      if (inputElem[i].type === 'radio') {
        (<HTMLElement>inputElem[i]).addEventListener('click', () => {
          clearError(inputElem[i]);
        });
      }
      if (inputElem[i].type === 'text') {
        (<HTMLElement>inputElem[i]).addEventListener('change', () => {
          processTextField(inputElem[i], this.modalService);
        })
      }
    }
  }
}
